import { atom } from 'jotai';

export const $LabelVisible = atom(true);
